module.exports = "/_next/static/images/f8319998dedaacd8f6ac5e7fd6dd2a0b-currency.svg";